<svg>
	<filter id="warning-color-interpolation-filter">
		<feComponentTransfer color-interpolation-filters="sRGB">
			<feFuncR id="fR" type="table" tableValues="0.937 1" />
			<feFuncG id="fG" type="table" tableValues="0.424 1" />
		</feComponentTransfer>
	</filter>
</svg>
